import request from '@/utils/request'
import config from '../../../config'
export function getDic(data) {
    return request({
        // url: `${config.VUE_APP_DIC_BASE_URl}/${data.projectUrl}${config.VUE_APP_DIC_CONTENT_URL}/${data.dicId}`,
        url: `${config.VUE_APP_DIC_BASE_URl}/${data.projectUrl}/${data.dicId}`,
        method: 'post',
        data
    })
}

export function getSelectData(options) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        method: 'post',
        params: {},
        data: {},
        ...options
    })
}


// WEBPACK FOOTER //
// ./src/components/LrInput/api.js